import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, ResolveFn, ActivatedRoute } from '@angular/router';
import { WebstoreProductService } from './webstore-product.service';

@Injectable()
export class ProductResolver {
    constructor(private productService: WebstoreProductService) {}

    resolve: ResolveFn<any> = async (route: ActivatedRouteSnapshot) => {
        // Get productUrl from params (set by parent matcher's posParams)
        // Falls back to route.url[0] for routes that don't use the matcher
        const currentUrlComponent = route.params['productUrl'] || route.url[0]?.path;
        if (!currentUrlComponent) {
            console.warn('ProductResolver: No product URL found in route');
            return null;
        }
        try {
            const product = await this.productService.getProductByUrlComponent(currentUrlComponent, true);
            return product;
        } catch (error) {
            // If resolver fails during SSR, return null to prevent 404 flash
            // Client-side routing will retry the API call
            console.warn('ProductResolver failed, will retry client-side:', error);
            return null;
        }
    };
}
